import React from "react";
import Nav from "../components/layout/Nav";
import HeroCarousel from "../components/Hero";
import BannerSection from "../components/Banner";
// import Products from "../components/Products";
import Footer from "../components/layout/Footer";
import Testimonials from "../components/Testimonials";
import WhyUs from "../components/WhyUs";
import HowItWorks from "../components/HowItWorks";
import CallToAction from "../components/CallToAction";
// import WhoWeAre from "../components/WhoWeAre";

const Home = () => {
  return (
    <>
      <Nav />
      <HeroCarousel />
      {/* <WhoWeAre/> */}
     <BannerSection/>
     {/* <Products/> */}
     <HowItWorks/>
     <WhyUs/>
     <CallToAction/>
     <Testimonials/>
     <Footer/>
    </>
  );
};

export default Home;
